<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <!-- <template #month="params">
        {{ params.params.month ? Number(params.params.month.split('-')[1]) + '月' : "-" }}
      </template> -->
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'monther',
      getListUrl: 'fxrec',
      breadcrumb: [
        { name: "财务管理", path: `` },
        { name: "月度分析表", path: `` },
      ],
      formInline: { year: undefined },
      formCtrl: [
        {
          label: "年份：",
          placeholder: "请选择年份",
          keyName: "year",
          type: 'year',
        },
      ],
      cols: [
        { prop: "month", label: "月份" },
        { prop: "freight", label: "运费总额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "tb_freight", label: "同比", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "hb_freight", label: "环比", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "cost", label: "营业成本", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "tb_cost", label: "同比", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "hb_cost", label: "环比", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "profit", label: "利润总额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "tb_profit", label: "同比", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "hb_profit", label: "环比", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: [
        'freight',
        // 'tb_freight',
        // 'hb_freight',
        'cost',
        // 'tb_cost',
        // 'hb_cost',
        'profit',
        // 'tb_profit',
        // 'hb_profit'
      ],
      baseParams: ['year'],
    };
  },
  methods: {
    dataObjHandler(v) {
      const o = {}
      for (const key in v) {
        if (Object.hasOwnProperty.call(v, key)) {
          if (key.includes('tb') || key.includes('hb')) {
            o[key] = v[key] + '%';
          } else {
            o[key] = v[key];
          }
        }
      }
      return o
    },
  },
  mounted() {
    // console.log({ ...this.formInline })
    this.formInline.year = this.DATE_OBJ.y
    // console.log({ ...this.formInline })
    this.getList()
  },
};
</script>
